// extracted by mini-css-extract-plugin
export const modalBackdrop = "modal-modules--modalBackdrop--34wQ8";
export const modalWrapper = "modal-modules--modalWrapper--3x6rN";